export default function worksFilter() {
  const categoryButtons = document.querySelectorAll('.p-works__searchBtn');
  categoryButtons.forEach((button) => {
    // カテゴリーを選択したとき
    button.addEventListener('click', function(event) {
      event.preventDefault();
      categoryButtons.forEach((btn) => btn.classList.remove('selected'));
      this.classList.add('selected');
    });
  });

  const colorCheckboxes = document.querySelectorAll('.colorCheckbox');
  // 検索ボタンが押された時の遷移先URL
  const buildUrl = () => {
    let url = '/works';
    const categoryButtons = document.querySelectorAll('.p-works__searchBtn');
    categoryButtons.forEach((button) => {
      if (button.classList.contains('selected')) {
        url = '/works/' + button.getAttribute('data-slug');
      }
    });

    let i = 0;
    let isFirst = true;
    colorCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        url += `${isFirst ? '?' : '&'}color%5B%5D=${checkbox.value}`;
        isFirst = false;
      }
    });

    return url;
  }

  const filterForm = document.getElementById('works-filter');
  if (filterForm) {
    // 検索ボタンが押されたとき
    filterForm.onsubmit = function(e) {
      e.preventDefault();  // デフォルトのフォーム送信を停止
      window.location.href = buildUrl();
    };
  }

  const resetButton = document.getElementById('works-filter-reset');
  if (resetButton) {
    // リセットボタンが押された時
    resetButton.addEventListener('click', (e) => {
      e.preventDefault();
      categoryButtons.forEach((btn) => btn.classList.remove('selected'));
      colorCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    });
  }
}
